import {
  getQueryWithParams,
  getQuery,
  postMutation,
} from "src/components/ApolloConnection/ApolloProviderComponent";
import {
  LIST_ALL_NOTIFICATIONS,
  GET_INVOICE_PDF,
} from "src/components/graphql/GraphQLquery";
import { snackbar } from "@mobiscroll/react5";
import {
  ADD_INSURANCE,
  READ_NOTIFICATION,
} from "src/components/graphql/GraphQLmutation";

export async function addInsurance(data) {
  try {
    let response = await postMutation(ADD_INSURANCE, data);
    
    if (!response || response.errors) {
      throw new Error(response?.errors?.[0]?.message || "Failed to add insurance");
    }

    const result = response?.data?.addInsurance;
    
    // Check for error response (statusCode >= 400)
    if (result?.statusCode && result.statusCode >= 400) {
      throw new Error(result?.message || "Failed to add insurance");
    }
    
    // Success case
    snackbar({
      message: result?.message || "Insurance added successfully.",
      color: "success",
    });
    return true;
  } catch (e) {
    snackbar({
      message: e.message,
      color: "danger",
    });
    console.error("Error at addInsurance:", e);
    return false;
  }
}

export async function listAllNotifications() {
  try {
    let response = await getQuery(LIST_ALL_NOTIFICATIONS);
    
    if (!response || response.errors) {
      throw new Error(response?.errors?.[0]?.message || "Failed to fetch notifications");
    }

    const result = response?.data?.listAllNotifications;
    
    // Check for error response (statusCode >= 400)
    if (result?.statusCode && result.statusCode >= 400) {
      throw new Error(result?.message || "Failed to fetch notifications");
    }
    
    // Success case - return data (no snackbar for list fetches)
    return result?.data || [];
  } catch (e) {
    snackbar({
      message: e.message,
      color: "danger",
    });
    console.error("Error at listAllNotifications:", e);
    return [];
  }
}

export async function getInvoicePdf(id) {
  try {
    let response = await getQueryWithParams(GET_INVOICE_PDF, { id });
    
    if (!response || response.errors) {
      throw new Error(response?.errors?.[0]?.message || "Failed to fetch invoice");
    }

    const result = response?.data?.getInvoice;
    
    // Check for error response (statusCode >= 400)
    if (result?.statusCode && result.statusCode >= 400) {
      throw new Error(result?.message || "Failed to fetch invoice");
    }
    
    // Success case
    if (result?.data) {
      snackbar({
        message: result?.message || "Invoice fetched successfully.",
        color: "success",
      });
      return result.data;
    }
    throw new Error("No invoice data returned");
  } catch (e) {
    snackbar({
      message: e.message,
      color: "danger",
    });
    console.error("Error at getInvoicePdf:", e);
    return null;
  }
}

export async function readNotification(data) {
  try {
    const response = await postMutation(READ_NOTIFICATION, data);

    if (!response || response.errors) {
      throw new Error(response?.errors?.[0]?.message || "Failed to read notification");
    }

    const result = response?.data?.readNotification;
    
    // Check for error response (statusCode >= 400)
    if (result?.statusCode && result.statusCode >= 400) {
      throw new Error(result?.message || "Failed to read notification");
    }
    
    // Success case
    return true;
  } catch (e) {
    snackbar({
      message: e.message,
      color: "danger",
    });
    console.error("Error at readNotification:", e);
    return false;
  }
}
